import { Component } from "./Component";
import { vp } from "../managers/vp";
import { settings } from "../const/Settings";
import { TopicManager } from "../managers/TopicManager";
import { MediaModel } from "../models/MediaModel";
import { DomUtils } from "socios-tools/utils/DomUtils";
export class MediaItemComponent extends Component {
    constructor() {
        super(...arguments);
        this._data = null;
    }
    init() {
        this._id = this.html.getAttribute('data-id');
        if (this.html.nodeName === 'A' && vp.mediaQueries.matches(settings.mediaQueries.mqCollapseMenu)) {
            const hash = this.html.getAttribute('href');
            if (hash) {
                const topicID = vp.topicManager.getTopicIDFromHash(hash);
                if (topicID) {
                    this.html.removeAttribute('href');
                    this.html.addEventListener('click', () => {
                        vp.topicManager.openTopic(topicID);
                    });
                }
            }
        }
        if (this.data.isLinkDump()) {
            const labelContainer = this.getHtml('label_container');
            if (labelContainer) {
                labelContainer.appendChild(DomUtils.createElement(`<img src="${vp.config.createImageUrl('sent-in.webp')}">`));
            }
            else {
                logger.error('cant set label');
            }
            const timeHtml = this.getHtml('datetime');
            if (timeHtml) {
                timeHtml.style.visibility = 'hidden';
            }
        }
    }
    get data() {
        if (!this._data) {
            this._data = new MediaModel(TopicManager.getDataFromTemplate(this._id));
        }
        return this._data;
    }
}
